/**
 * 校验事件模板
 * 正则表达式校验欠完善？
 * @param {string} template 事件模板
 */
export const validate = (template) => {
  // if (!isString(template) || !template){
  //   return {
  //     success: false,
  //     errorMsg: `${template} 事件模板须为字符串且不能为空`
  //   };
  // }

  const events = template.split(",");
  let result;
  events.some((event) => {
    if (!event.length) {
      result = {
        success: false,
        errorMsg: `子事件不能为空`,
      };
      return true;
    }

    const [_, ...eventNames] = event.split(":");
    eventNames.forEach((eventName) => {
      // props 事件名必须以 on 起始
      if (eventName !== "change" && eventName.slice(0, 2) !== "on") {
        result = {
          success: false,
          errorMsg: `子事件 ${event} 的事件类型不合法`,
        };
        return true;
      }
    });
    return false;
  });

  if (result) return result;

  return {
    success: true,
    errorMsg: "",
  };
};

/**
 * 解析事件模板 "${fieldId}:change" => { raw, event: { fieldId: [ eventName ] } }
 * 在消费时校验 fieldId 字段存在与否
 * @param {string} template 事件模板 "${fieldId}:change,..." | "fieldId:change,..."
 * @return {object} { raw, event: { fieldId: [ eventName ] } }
 */
export const parse = (template) => {
  if (!template) return { event: {} };
  const validateResult = validate(template);
  console.warn(validateResult.success, validateResult.errorMsg);

  const event = {};
  const events = template.split(",");

  events.forEach((e) => {
    const [fieldIdStr, ...eventNames] = e.split(":");
    const matches = fieldIdStr.match(/(\${(.*)})/);
    const fieldId = matches && matches.length ? matches[2] : fieldIdStr;
    if (!event[fieldId]) {
      event[fieldId] = [];
    }

    // 保证事件的唯一性
    if (eventNames.length) {
      eventNames.forEach((eventName) => {
        if (!event[fieldId].includes(eventName)) {
          event[fieldId].push(eventName);
        }
      });
    } else if (!event[fieldId].includes("change")) {
      event[fieldId].push("change");
    }
  });

  return {
    event,
  };
};
